import { render, staticRenderFns } from "./EditModalCleaner.vue?vue&type=template&id=56229cec&scoped=true"
import script from "./EditModalCleaner.vue?vue&type=script&lang=js"
export * from "./EditModalCleaner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56229cec",
  null
  
)

export default component.exports